import React from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from '../Sidebar';
import GlobalAnnouncementBanner from '../GlobalAnnouncementBanner';

interface DashboardLayoutProps {
    children: React.ReactNode;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
    const navigate = useNavigate();

    const handleGoHome = () => {
        navigate('/');
    };

    return (
        <div className="flex h-screen w-full overflow-hidden">
            <Sidebar onGoHome={handleGoHome} />
            <main className="flex-1 h-full relative overflow-hidden bg-zinc-50/80 dark:bg-zinc-950/70 backdrop-blur-3xl">
                <div className="w-full h-full flex flex-col overflow-hidden">
                    <GlobalAnnouncementBanner />
                    {children}
                </div>
            </main>
        </div>
    );
};

export default DashboardLayout;
